import { useQuery } from '@tanstack/react-query';

import QueryKeys from '../../constants/queryKeys';

// helpers
import { BaseError } from '../../helpers/BaseError';

import { PushIntegrationModel } from '../../models/pushProvider.model';

// services
import API from '../../services/api';

const getPushIntegrations = async (): Promise<PushIntegrationModel[]> => {
    const { data } = await API.getPushIntegrations();
    return data;
};

export default function usePushIntegrationQuery() {
    return useQuery<PushIntegrationModel[], BaseError>({
        queryKey: QueryKeys.pushIntegrations,
        queryFn: () => getPushIntegrations(),
        staleTime: 1000 * 60 * 60 * 2, // 2 hours
    });
}
